// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"e0fc9913","260":"88ac7acd","387":"e0fc9913","595":"5bb6b02a","866":"e98a0613"}[chunkId] + ".chunk.css";
};